import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label", "children", "closeable", "onClose", "paddingBlock", "paddingInline"],
  _excluded2 = ["as", "children"];
import { LayoutBoxBreezeBorder } from '../Layout/LayoutBoxBreezeBorder';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { LayoutSpaceVertical } from '../Layout/LayoutSpaceVertical';
import { Heading } from '../Typography';
import { useModal } from '../Modal/Modal';
import { ButtonIconOnly } from '../Button';
import { useTheme } from '../useTheme';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AlertBreeze = _ref => {
  let {
      'aria-label': ariaLabel = 'Close',
      children,
      closeable,
      onClose,
      paddingBlock = 'space',
      paddingInline = 'space'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isModalOpen,
    handleModalToggle
  } = useModal(true);
  const {
    isTrellisLight
  } = useTheme();
  const borderRadius = isTrellisLight ? 'border-radius' : 'unset';
  const handleOnClose = () => {
    handleModalToggle();
    onClose === null || onClose === void 0 || onClose();
  };
  if (!isModalOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(LayoutBoxBreezeBorder, Object.assign({}, rest, {
    background: "background-color-light",
    borderRadius: borderRadius,
    paddingBlock: paddingBlock,
    paddingInline: paddingInline,
    position: "relative",
    children: /*#__PURE__*/_jsxs(LayoutHorizontal, {
      paddingInline: "space-xxs",
      children: [/*#__PURE__*/_jsx(LayoutSpaceVertical, {
        flex: 1,
        gap: "space-3xs",
        children: children
      }), closeable && /*#__PURE__*/_jsx(ButtonIconOnly, {
        "aria-label": ariaLabel,
        onClick: handleOnClose,
        size: "xs",
        variant: "transparent",
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })]
    })
  }));
};
const AlertBreezeTitle = _ref2 => {
  let {
      as = 'h5',
      children
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Heading, Object.assign({
    as: as
  }, rest, {
    children: children
  }));
};
AlertBreeze.Title = AlertBreezeTitle;